<template>
  <transition name="modal-fade">
    <div class="info_modal" v-show="storyModalActive">
      <div class="info_modal_inner">
        <div class="row flush final_modal align_center">
          <defs>
            <rect id="path-1" x="0" y="0" width="300" height="200" rx="3"></rect>
            <rect id="path-2" x="0" y="0" width="300" height="200" rx="3"></rect>
          </defs>

          <svg width="100%" height="100%" viewBox="0 0 1167 606">

            <g v-show="intro_modal_active" id="story_intro_modal">
              <rect fill="#DFC8E4" opacity="0.95" x="-20" y="-100" width="1280" height="810" rx="10"></rect>
              <g transform="translate(329.000000, 208.000000)">
                <g id="button_container" @click="next_slide" transform="translate(185.000000, 140.000000)">
                  <rect fill="#FFFFFF" x="0" y="0" width="140" height="44" rx="22"></rect>
                  <text id="PROCEED" font-family="ScopeOne-Regular, Scope One" font-size="16" font-weight="normal" line-spacing="16" fill="#666666">
                    <tspan x="36.2361245" y="27.7734375">PROCEED</tspan>
                  </text>
                </g>
                <text font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                  <tspan x="0" y="23">Your teacher has activities to learn more about</tspan>
                  <tspan x="0" y="53">bystanding and allying. Please click to proceed</tspan>
                  <tspan x="0" y="83">once you have completed the exercise.</tspan>
                </text>
              </g>
            </g>

            <g v-show="character_stories_active" id="storyline_choice_modal">
              <rect fill="#AD88B4" opacity="0.95" x="-20" y="-100" width="1280" height="810" rx="10"></rect>
              <g transform="translate(194.500000, 68.000000)">
                <text font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                  <tspan x="66.251953125" y="23">Now that you have learned more about allying, let’s explore</tspan>
                  <tspan x="89.5898438" y="53">some of the different point of views in the situation Aye</tspan>
                  <tspan x="110.0820312" y="83">witnessed between Skylar and Dylan. Please click a</tspan>
                  <tspan x="175.945312" y="113">character to explore their perspective.</tspan>
                </text>

                <!-- SKYLAR'S BUTTON -->
                <g @click="trigger_skylar_story" id="button_container" transform="translate(80.000000, 170.000000)" fill="#D8C2DD">
                  <g id="skylar_story_button">
                    <use fill="#D8C2DD" fill-rule="evenodd" xlink:href="#path-1"></use>
                    <rect stroke="#FFFFFF" stroke-width="2" x="1" y="1" width="298" height="198" rx="3"></rect>
                  </g>
                  <path d="M150,122 C130.670034,122 115,106.329966 115,87 C115,67.6700338 130.670034,52 150,52 C169.329966,52 185,67.6700338 185,87 C185,106.329966 169.329966,122 150,122 Z M150.154817,113.998484 C158.822654,113.924076 165.104382,111.258867 169,106.002858 C164.093464,100.789393 157.811736,98.1230496 150.154817,98.0038271 C142.497897,97.8846045 136.112958,100.550948 131,106.002858 C135.10204,111.407684 141.486979,114.072893 150.154817,113.998484 Z M165.041434,84.434843 C168.126365,68.7965518 163.470945,65.9422602 155.293314,64.0599562 C157.366525,63.3926036 160.382557,55.1281524 150.049841,55.0013818 C139.717125,54.8746111 142.620743,63.5117048 144.22281,64.0682896 C136.423232,66.1018717 131.967813,69.6221104 134.914963,84.434843 C135.506905,87.4100148 139.533366,95.799771 150.049841,95.9969196 C160.566316,96.1940682 164.560881,86.870885 165.041434,84.434843 Z M149.922031,95 C142.233105,95 136,88.3206286 136,80.0812064 C136,79.0521259 136.223745,77.0080444 136.408902,76.0376093 C137.014427,75.377473 137.31549,74.557297 137.31549,73.0703623 C137.31549,72.426851 138.062328,71.6202919 138.33517,71 C138.108575,72.7240142 138.056252,74.3124914 138.828736,75.3613587 C139.132916,75.7743693 138.155439,76.9184901 137.609034,77.3221214 C140.384006,77.0021523 141.090778,77.1928755 140.524186,73.5694655 C140.459851,73.1580383 140.75758,72.0217157 141.371035,71.4313347 C142.029399,72.558787 141.935442,73.5569013 142.327578,74.3984713 C142.704344,75.2070583 141.774788,75.7812146 143.413279,77.5221158 C143.58302,75.5134516 144.468494,75.6796722 144.464786,74.7225242 C144.464256,74.5857619 143.413279,72.5528269 144.725165,71.4313347 C144.842067,73.2639552 145.509185,73.5479429 145.829921,74.2227588 C146.150657,74.8975746 145.21698,76.2554841 146.910473,77.3221214 C146.936473,77.0707555 146.80866,76.162563 147.515895,75.1519826 C147.816443,74.7225242 147.626206,73.5694655 147.515895,73.0703623 C147.405584,72.5712591 147.739091,72.0706106 148.136664,71.857813 C149.922031,72.7762203 148.604274,73.204479 148.604274,74.5481361 C148.604274,75.7972186 149.56401,75.8248117 149.792665,77.3221214 C150.0045,77.0319047 150.685143,76.8322894 150.597079,74.8443752 C150.579177,74.4402619 151.313327,74.2227588 151.101666,72.9304103 C151.022412,72.4465044 151.500681,71.857813 151.938525,71.4313347 C151.938525,75.3613587 153.959345,76.6205955 153.242582,77.7229933 C153.848019,77.7135679 154.725547,76.8287575 154.884885,76.0376093 C155.044223,75.2464612 154.335906,75.446566 154.488549,74.3984713 C154.519746,74.1842635 155.380202,72.7325129 155.681265,71.857813 C156.908795,74.2227588 155.541291,76.9354874 157.029406,77.7229933 C156.882222,76.3166303 157.701563,76.1018884 158.181644,75.1519826 C158.486827,74.5481361 157.830421,72.4207113 159.126136,71.857813 C159.838882,76.6450981 160.448012,74.0066499 161.76206,77.8845782 C161.973412,77.5221158 162.707272,75.8755829 162.151289,74.7225242 C161.595306,73.5694655 161.993491,72.1625246 162.830561,71.7439088 C164.369454,74.8443752 163.276027,73.5694655 163.63896,77.5791052 C163.784095,77.3387443 163.904441,77.1310849 164,76.956127 C163.896041,79.0374447 163.844061,80.0791378 163.844061,80.0812064 C163.844061,88.3206286 157.610956,95 149.922031,95 Z" id="Profile:-Skylar" fill="#FFFFFF"></path>
                  <text id="SKYLAR" font-family="ScopeOne-Regular, Scope One" font-size="16" font-weight="normal" line-spacing="16" letter-spacing="2" fill="#FFFFFF">
                    <tspan x="112.8455" y="143.773438">SKYLAR</tspan>
                  </text>
                </g>

                <!-- DYLAN'S BUTTON -->
                <g @click="trigger_dylan_story" id="button_container" transform="translate(400.000000, 170.000000)" fill="#D8C2DD">
                  <g id="dylan_story_button">
                    <use fill="#D8C2DD" fill-rule="evenodd" xlink:href="#path-2"></use>
                    <rect stroke="#FFFFFF" stroke-width="2" x="1" y="1" width="298" height="198" rx="3"></rect>
                  </g>
                  <path d="M149,122 C129.670034,122 114,106.329966 114,87 C114,67.6700338 129.670034,52 149,52 C168.329966,52 184,67.6700338 184,87 C184,106.329966 168.329966,122 149,122 Z M149.154817,113.998484 C157.822654,113.924076 164.104382,111.258867 168,106.002858 C163.093464,100.789393 156.811736,98.1230496 149.154817,98.0038271 C141.497897,97.8846045 135.112958,100.550948 130,106.002858 C134.10204,111.407684 140.486979,114.072893 149.154817,113.998484 Z M149.01553,61.000673 C140.568982,60.9410163 135.062565,64.8484992 133.495958,72.3206546 C134.778374,71.6783898 137.366129,70.4203417 144.956565,70.433991 C153.537564,70.4494215 162.032399,74.3581773 162.013162,78 C162.062256,78 163.71348,77.9806454 164.013162,78 C163.970804,91.6467285 155.019607,94.9294434 149.01553,95 C143.011454,95.0705566 133.605448,92.6005859 134.013162,78 C133.814676,78.0089795 133.07014,78.0013989 133.013162,78 C132.721821,88.6056887 137.24248,96 149.01553,96 C160.788581,96 165.012628,88.2482454 165.012628,77.9806454 C165.078278,66.1937428 159.091417,61.0718374 149.01553,61.000673 Z M130.99707,75.0158691 C129.574677,75.9417367 130.079118,76.960649 130.99707,76.9732359 C135.388807,77.0334551 155.498429,77 158,77 C160.853811,77 160.770068,76.3884359 158.560547,75.0158691 C154.937378,72.7651367 151.320892,71.5551633 145.025146,71.4696045 C138.083119,71.3752627 134.920288,72.4621582 130.99707,75.0158691 Z" id="Profile:-Dylan" fill="#FFFFFF"></path>
                  <text id="DYLAN" font-family="ScopeOne-Regular, Scope One" font-size="16" font-weight="normal" line-spacing="16" letter-spacing="2" fill="#FFFFFF">
                    <tspan x="117.810343" y="143.773438">DYLAN</tspan>
                  </text>
                </g>
                <g id="button_container" v-show="storyEnd" @click="modalClose" transform="translate(319.500000, 420.000000)">
                  <rect fill="#FFFFFF" x="0" y="0" width="140" height="44" rx="22"></rect>
                  <text id="PROCEED" font-family="ScopeOne-Regular, Scope One" font-size="16" font-weight="normal" line-spacing="16" fill="#666666">
                    <tspan x="36.2361245" y="27.7734375">PROCEED</tspan>
                  </text>
                </g>
              </g>
            </g>


              <g v-show="story_selected">
                <rect fill="#AD88B4" opacity="0.95" x="-20" y="-250" width="1280" height="1300" rx="10"></rect>
                   <!-- transform="translate(-60.000000, -20.000000)" -->

                   <rect v-show="previous_arrow_active && slideNumber > 1" @click="trigger_previous_image" x='0px' y='-20px' width="200px" height="1000px" class='cursor-pointer' fill="transparent" />
                   <rect v-show="next_arrow_active" @click="trigger_next_image" class='cursor-pointer' x='975px' y='-20px' width="200px" height="1000px" fill="transparent" />


                <g  :transform="arrowsTransform" fill="#FFFFFF">

                  <!-- PREVIOUS BUTTON -->


                  


                  <g id="previous" v-show="previous_arrow_active && slideNumber > 1" @click="trigger_previous_image" transform="translate(20.000000, 0.000000)">
                    <g transform="translate(0.000000, -24.000000)">
                      <polygon id="arrow" points="101.336032 348 104 350.82 95.3468286 360 104 369.18 101.336032 372 90 360"></polygon>
                    </g>
                    <!-- <rect fill="#AD88B4" opacity="0" x="28" y="-100" width="150" height="810" rx="10"></rect> -->
                  </g>

                  

                  <!-- NEXT BUTTON -->

                  
                  
                  <g id="next" v-show="next_arrow_active" @click="trigger_next_image" transform="translate(2.000000, 0.000000)">
                    <g transform="translate(0.000000, -24.000000)">
                      <polygon id="arrow" points="1179.66397 348 1177 350.82 1185.65317 360 1177 369.18 1179.66397 372 1191 360"></polygon>
                    </g>
                    <!-- <rect fill="#AD88B4" opacity="0" x="1087" y="-100" width="150" height="810" rx="10"></rect> -->
                  </g>

                </g>

              </g>
              <g>
                <g v-show="selected_character == 'dylan'">
                  <dylan_story_1 v-show="slideNumber === 1"></dylan_story_1>
                  <dylan_story_2 v-show="slideNumber === 2"></dylan_story_2>
                  <dylan_story_3 v-show="slideNumber === 3"></dylan_story_3>
                  <dylan_story_4 v-show="slideNumber === 4"></dylan_story_4>
                  <dylan_story_5 v-show="slideNumber === 5"></dylan_story_5>
                  <dylan_story_6 v-show="slideNumber === 6"></dylan_story_6>
                  <dylan_story_7 v-show="slideNumber === 7"></dylan_story_7>
                  <dylan_story_8 v-show="slideNumber === 8"></dylan_story_8>
                  <dylan_story_9 v-show="slideNumber === 9"></dylan_story_9>
                  <dylan_story_10 v-show="slideNumber === 10"></dylan_story_10>
                  <dylan_story_11 v-show="slideNumber === 11"></dylan_story_11>
                  <dylan_story_12 v-show="slideNumber === 12"></dylan_story_12>
                  <dylan_story_13 v-show="slideNumber === 13"></dylan_story_13>
                  <dylan_story_14 v-show="slideNumber === 14"></dylan_story_14>
                  <dylan_story_15 v-show="slideNumber === 15"></dylan_story_15>
                  <dylan_story_16 v-show="slideNumber === 16"></dylan_story_16>
                  <dylan_story_17 v-show="slideNumber === 17"></dylan_story_17>
                  <dylan_story_18 v-show="slideNumber === 18"></dylan_story_18>
                  <dylan_story_19 v-show="slideNumber === 19"></dylan_story_19>
                  <dylan_story_20 v-show="slideNumber === 20"></dylan_story_20>
                  <dylan_story_21 v-show="slideNumber === 21"></dylan_story_21>
                  <dylan_story_22 v-show="slideNumber === 22"></dylan_story_22>
                  <dylan_story_23 v-show="slideNumber === 23"></dylan_story_23>
                  <dylan_story_24 v-show="slideNumber === 24"></dylan_story_24>
                </g>

                <g v-show="selected_character == 'skylar'">
                  <skylar_story_1 v-show="slideNumber === 1"></skylar_story_1>
                  <skylar_story_2 v-show="slideNumber === 2"></skylar_story_2>
                  <skylar_story_3 v-show="slideNumber === 3"></skylar_story_3>
                  <skylar_story_4 v-show="slideNumber === 4"></skylar_story_4>
                  <skylar_story_5 v-show="slideNumber === 5"></skylar_story_5>
                  <skylar_story_6 v-show="slideNumber === 6"></skylar_story_6>
                  <skylar_story_7 v-show="slideNumber === 7"></skylar_story_7>
                  <skylar_story_8 v-show="slideNumber === 8"></skylar_story_8>
                  <skylar_story_9 v-show="slideNumber === 9"></skylar_story_9>
                  <skylar_story_10 v-show="slideNumber === 10"></skylar_story_10>
                  <skylar_story_11 v-show="slideNumber === 11"></skylar_story_11>
                  <skylar_story_12 v-show="slideNumber === 12"></skylar_story_12>
                  <skylar_story_13 v-show="slideNumber === 13"></skylar_story_13>
                  <skylar_story_14 v-show="slideNumber === 14"></skylar_story_14>
                  <skylar_story_15 v-show="slideNumber === 15"></skylar_story_15>
                  <skylar_story_16 v-show="slideNumber === 16"></skylar_story_16>
                  <skylar_story_17 v-show="slideNumber === 17"></skylar_story_17>
                  <skylar_story_18 v-show="slideNumber === 18"></skylar_story_18>
                  <skylar_story_19 v-show="slideNumber === 19"></skylar_story_19>
                  <skylar_story_20 v-show="slideNumber === 20"></skylar_story_20>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
  </transition>
</template>


<style scoped lang="scss">
  .layer {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .index-2 {
    z-index: 2;
  }

  .layer-inactive {
    pointer-events: none;
  }

  #button_container,
  #next,
  #previous {
    cursor: pointer;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .animateSlide {
    &.forward {
      animation: fadeinout 10s linear;
    }
  }
</style>


<script>
  import anime from 'animejs';
  import animations from '@/assets/js/animations';

  // DYLAN STORY
  import dylan_story_1 from '../../../svg/characters/dylan_story/dylan_story_1';
  import dylan_story_2 from '../../../svg/characters/dylan_story/dylan_story_2';
  import dylan_story_3 from '../../../svg/characters/dylan_story/dylan_story_3';
  import dylan_story_4 from '../../../svg/characters/dylan_story/dylan_story_4';
  import dylan_story_5 from '../../../svg/characters/dylan_story/dylan_story_5';
  import dylan_story_6 from '../../../svg/characters/dylan_story/dylan_story_6';
  import dylan_story_7 from '../../../svg/characters/dylan_story/dylan_story_7';
  import dylan_story_8 from '../../../svg/characters/dylan_story/dylan_story_8';
  import dylan_story_9 from '../../../svg/characters/dylan_story/dylan_story_9';
  import dylan_story_10 from '../../../svg/characters/dylan_story/dylan_story_10';
  import dylan_story_11 from '../../../svg/characters/dylan_story/dylan_story_11';
  import dylan_story_12 from '../../../svg/characters/dylan_story/dylan_story_12';
  import dylan_story_13 from '../../../svg/characters/dylan_story/dylan_story_13';
  import dylan_story_14 from '../../../svg/characters/dylan_story/dylan_story_14';
  import dylan_story_15 from '../../../svg/characters/dylan_story/dylan_story_15';
  import dylan_story_16 from '../../../svg/characters/dylan_story/dylan_story_16';
  import dylan_story_17 from '../../../svg/characters/dylan_story/dylan_story_17';
  import dylan_story_18 from '../../../svg/characters/dylan_story/dylan_story_18';
  import dylan_story_19 from '../../../svg/characters/dylan_story/dylan_story_19';
  import dylan_story_20 from '../../../svg/characters/dylan_story/dylan_story_20';
  import dylan_story_21 from '../../../svg/characters/dylan_story/dylan_story_21';
  import dylan_story_22 from '../../../svg/characters/dylan_story/dylan_story_22';
  import dylan_story_23 from '../../../svg/characters/dylan_story/dylan_story_23';
  import dylan_story_24 from '../../../svg/characters/dylan_story/dylan_story_24';

  // SKYLAR STORY
  import skylar_story_1 from '../../../svg/characters/skylar_story/skylar_story_1';
  import skylar_story_2 from '../../../svg/characters/skylar_story/skylar_story_2';
  import skylar_story_3 from '../../../svg/characters/skylar_story/skylar_story_3';
  import skylar_story_4 from '../../../svg/characters/skylar_story/skylar_story_4';
  import skylar_story_5 from '../../../svg/characters/skylar_story/skylar_story_5';
  import skylar_story_6 from '../../../svg/characters/skylar_story/skylar_story_6';
  import skylar_story_7 from '../../../svg/characters/skylar_story/skylar_story_7';
  import skylar_story_8 from '../../../svg/characters/skylar_story/skylar_story_8';
  import skylar_story_9 from '../../../svg/characters/skylar_story/skylar_story_9';
  import skylar_story_10 from '../../../svg/characters/skylar_story/skylar_story_10';
  import skylar_story_11 from '../../../svg/characters/skylar_story/skylar_story_11';
  import skylar_story_12 from '../../../svg/characters/skylar_story/skylar_story_12';
  import skylar_story_13 from '../../../svg/characters/skylar_story/skylar_story_13';
  import skylar_story_14 from '../../../svg/characters/skylar_story/skylar_story_14';
  import skylar_story_15 from '../../../svg/characters/skylar_story/skylar_story_15';
  import skylar_story_16 from '../../../svg/characters/skylar_story/skylar_story_16';
  import skylar_story_17 from '../../../svg/characters/skylar_story/skylar_story_17';
  import skylar_story_18 from '../../../svg/characters/skylar_story/skylar_story_18';
  import skylar_story_19 from '../../../svg/characters/skylar_story/skylar_story_19';
  import skylar_story_20 from '../../../svg/characters/skylar_story/skylar_story_20';

  export default {
    components: {
      dylan_story_1,
      dylan_story_2,
      dylan_story_3,
      dylan_story_4,
      dylan_story_5,
      dylan_story_6,
      dylan_story_7,
      dylan_story_8,
      dylan_story_9,
      dylan_story_10,
      dylan_story_11,
      dylan_story_12,
      dylan_story_13,
      dylan_story_14,
      dylan_story_15,
      dylan_story_16,
      dylan_story_17,
      dylan_story_18,
      dylan_story_19,
      dylan_story_20,
      dylan_story_21,
      dylan_story_22,
      dylan_story_23,
      dylan_story_24,

      skylar_story_1,
      skylar_story_2,
      skylar_story_3,
      skylar_story_4,
      skylar_story_5,
      skylar_story_6,
      skylar_story_7,
      skylar_story_8,
      skylar_story_9,
      skylar_story_10,
      skylar_story_11,
      skylar_story_12,
      skylar_story_13,
      skylar_story_14,
      skylar_story_15,
      skylar_story_16,
      skylar_story_17,
      skylar_story_18,
      skylar_story_19,
      skylar_story_20
    },
    data() {
      return {
        storyPlayed: false,
        storyEnd: false,

        intro_modal_active: true,
        selected_character: '',
        character_stories_active: false,

        skylar_story: '',
        dylan_story: '',
        story_selected: false,

        animateSlide: '',
        previous_arrow_active: false,
        next_arrow_active: true,
        dylanCurrentNumber: 1,
        skylarCurrentNumber: 1,
        slideNumber: 1
      }
    },
    computed: {
      arrowsTransform: () =>{  
        // sorry 
        // var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        // if chrome
        // if (isChrome) return "translate(-60.000000, -20.000000)"
        // if safari or firefox
        return 'translate(500.000000, 250.000000)'
      }
    },
    props: ['storyModalActive', 'name'],
    methods: {
      modalClose() {
        this.$emit('close')
      },
      next_slide() {
        this.intro_modal_active = false
        this.character_stories_active = true
      },
      restart_story() {
        this.previous_arrow_active = false;
        this.skylarCurrentNumber = 1;
        this.dylanCurrentNumber = 1;
        this.slideNumber = 1;
        this.character_stories_active = false;
        this.story_selected = true;
      },
      trigger_skylar_story() {
        this.selected_character = 'skylar';
        this.restart_story();
      },
      trigger_dylan_story() {
        this.selected_character = 'dylan';
        this.restart_story();
      },
      trigger_next_image() {
        this.animateSlide = 'forward'; // transition class, not working

        if (this.dylanCurrentNumber > 0) {
          this.previous_arrow_active = true;
          this.storyEnd = false;
        }
        if (this.dylanCurrentNumber === 24 || this.skylarCurrentNumber === 20) {
          this.character_stories_active = true;
          this.story_selected = false;
          this.storyEnd = true;
        }
        if (this.selected_character === 'dylan') {
          this.dylanCurrentNumber += 1
          this.slideNumber += 1
        }
        if (this.selected_character === 'skylar') {
          this.skylarCurrentNumber += 1
          this.slideNumber += 1
        }
      },
      trigger_previous_image() {
        this.animateSlide = 'backward'; // also not doing anything

        if (this.dylanCurrentNumber >  1 && this.dylanCurrentNumber <= 24 && this.slideNumber > 1 || this.skylarCurrentNumber > 1 && this.skylarCurrentNumber <= 20 && this.slideNumber > 1) {

          this.next_arrow_active = true;

          // this.slideNumber -= 1
          // console.log(this.slideNumber)

          // if (this.dylanCurrentNumber > 1 || this.skylarCurrentNumber > 1) {
          //   this.previous_arrow_active = true;
          // }

          if (this.selected_character === 'dylan') {
            this.dylanCurrentNumber -= 1
            this.slideNumber -= 1
          }

          if (this.selected_character === 'skylar') {
            this.skylarCurrentNumber -= 1
            this.slideNumber -= 1
          }

        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// storyModal.vue?8eedfce0